export { Menu3 as default } from './Menu3';
